import { render, staticRenderFns } from "./RallyRoundBackgroundImageChooser.vue?vue&type=template&id=2985117f&"
import script from "./RallyRoundBackgroundImageChooser.vue?vue&type=script&lang=ts&"
export * from "./RallyRoundBackgroundImageChooser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports